export const HoablInvestedUserConstants = {
    message : 96,
    messageBody : 110,
    displayName : 35,
    options : 35
}